// /frontend/src/Pages/Employer/components/Sidebar.jsx
// Exact copy of Admin sidebar, with only employer‑relevant links.

import React from "react";
import { Link } from "react-router-dom";
import { LogoutLink } from "../../Logout/Logout";

const EmployerSidebar = ({ isOpen }) => {
  return (
    <nav
      className={`sidebar sidebar-offcanvas ${isOpen ? "active" : ""}`}
      id="sidebar"
    >
      <ul className="nav">
        {/* ─── Dashboard ─── */}
        <li className="nav-item">
          <Link className="nav-link" to="/Employer/Dashboard">
            <span className="menu-title">Dashboard</span>
            <i className="mdi mdi-home menu-icon"></i>
          </Link>
        </li>

        {/* ─── Admin Jobs (with sub‑menu) ─── */}
        <li className="nav-item">
          <Link
            className="nav-link"
            data-bs-toggle="collapse"
            to="#employer-jobs"
            aria-expanded="false"
            aria-controls="employer-jobs"
          >
            <span className="menu-title">Jobs</span>
            <i className="menu-arrow"></i>
            <i className="mdi mdi-briefcase menu-icon"></i>
          </Link>
          <div className="collapse" id="employer-jobs">
            <ul className="nav flex-column sub-menu">
              <li className="nav-item">
                <Link className="nav-link" to="/Admin/TBS-Add-Job">
                  Add New Job
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/Admin/Test-Manage-Jobs">
                  Manage Jobs
                </Link>
              </li>
            </ul>
          </div>
        </li>

        {/* ─── Change Password ─── */}
        <li className="nav-item">
          <Link className="nav-link" to="/Admin/Test-Change-Password">
            <span className="menu-title">Change Password</span>
            <i className="mdi mdi-repeat menu-icon"></i>
          </Link>
        </li>

        {/* ─── Logout ─── */}
        <li className="nav-item">
          <LogoutLink className="nav-link">
            <span className="menu-title">Logout</span>
            <i className="mdi mdi-logout menu-icon"></i>
          </LogoutLink>
        </li>
      </ul>
    </nav>
  );
};

export default EmployerSidebar;
